



















































import '@/assets/styles/styles.sass'
import { message } from './store/modules/notifications'
import { updateMixin } from '@/utils/mixins/updateMixin'
import AlertDialog from './components/AlertDialog.vue'

export default updateMixin.extend({
  components: { AlertDialog },
  name: 'App',
  computed: {
    snackbarModel: {
      get() {
        return this.$store.getters['notifications/snack']
      },
      set(value) {
        this.$store.commit('notifications/snack', value)
      },
    },
    snackMessage(): message {
      return this.$store.getters['notifications/snackMessage']
    },
  },
  created() {
    const theme = localStorage.getItem('theme')
    if (theme) {
      const newtheme = JSON.parse(theme)
      this.$vuetify.theme.themes = Object.assign(
        this.$vuetify.theme.themes,
        newtheme,
      )
    }
    const dark = localStorage.getItem('darkMode')
    if (dark === 'true') {
      this.$vuetify.theme.dark = true
    }
    if (this.$store.getters.profile) {
      this.$i18n.locale = this.$store.getters.profile.lang
      this.$vuetify.lang.current = this.$store.getters.profile.lang
    }
  },
})
